import { filterProps } from '../../../theming'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function extractStyleSystemProps(others) {
  const {
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    inset,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    tal,
    va,
    fontSize,
    fw,
    b,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio,
    outline,
    textShadow,
    boxShadow,
    pointerEvents,
    filter,
    ...rest
  } = others;
  const styleSystemProps = filterProps({
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    w,
    miw,
    maw,
    h,
    mih,
    mah,
    bg,
    c,
    fill,
    opacity,
    pos,
    top,
    left,
    bottom,
    right,
    inset,
    display,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignContent,
    alignItems,
    alignSelf,
    flexDirection,
    justifyContent,
    flexWrap,
    order,
    gap,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    ta,
    tal,
    va,
    fontSize,
    fw,
    b,
    bs,
    bc,
    bw,
    btw,
    bbw,
    blw,
    brw,
    br,
    btr,
    bbr,
    btlr,
    btrr,
    bblr,
    bbrr,
    transition,
    transform,
    backgroundImage,
    backgroundSize,
    backgroundRepeat,
    backgroundPosition,
    objectFit,
    aspectRatio,
    outline,
    textShadow,
    boxShadow,
    pointerEvents,
    filter
  });
  return {
    styleSystemProps,
    rest: rest
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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